import * as edulaiInstance from '../../api/instances/edulaiInstance';
import { saveDataToLocalStorage } from '../utilsFunctions';

export function setApplicationInterceptors() {
  edulaiInstance.setRequestInterceptor();
  edulaiInstance.setResponseInterceptor();
}

export function saveAuthDataToLocalStorage(authResponse) {
  const { access_token, refresh_token } = authResponse;
  saveDataToLocalStorage('token', access_token);
  saveDataToLocalStorage('refresh_token', refresh_token);
}

export function getAuthToken() {
  return localStorage.token;
}

export function getRefreshToken() {
  return localStorage.refresh_token;
}
